import { useState, useEffect } from 'react'

import { Text, Icon } from 'components/common'
import LikeDislikeStyle from './style'

const LikeDislike = (props) => {
    const [likeDislike, setLikeDislike] = useState([0, 0])

    useEffect(() => {
        let total = props.liked + props.disliked;
        let percentLike = props.liked > 0 ? (props.liked / total) * 100 : 0;
        let percentDislike = props.disliked > 0 ? (props.disliked / total) * 100 : 0;

        setLikeDislike([percentLike, percentDislike]);
    }, [props.liked, props.disliked])

    return (
        <LikeDislikeStyle className="like-dislike flexBox alignMiddle">
            <Icon className='op-messages darkGrey' />
            <Text tag={'p'} className='h8 PopReg darkGrey' text={`${props.liked}/${props.disliked}`} />
            <div className='like-unlike flexBoxColumn'>
                <div className='like' style={{ width: `${likeDislike[0]}%` }}></div>
                <div className='dislike' style={{ width: `${likeDislike[1]}%` }}></div>
            </div>
        </LikeDislikeStyle>
    )
}

export default LikeDislike
